@if (corporateTaxEntity$ | async) {
    <form [formGroup]="enkelvoudigFg">

        <div formArrayName="specificatieVerliezen">
            @for (item of specificatieVerliezen.controls; track item; let i = $index) {
                <div [formGroupName]="i">
                    <div class="row mb-0.5">
                        <div class="col-auto">
                            <snelstart-ui-bsn-form-control
                                    [label]="i === 0 ? 'Fiscaal nummer vennootschap' : ''"
                                    [required]="true"
                                    class="custom-input-250"
                                    formControlName="rsinMaatschappijVerlies"
                                    id="rsinMaatschappijVerlies"
                            >
                            </snelstart-ui-bsn-form-control>
                        </div>

                        <div class="col-auto">
                            <snelstart-ui-date-form-control
                                    [label]="i === 0 ? 'Aanvang' : ''"
                                    [required]="true"
                                    class="custom-input-150"
                                    formControlName="startBoekjaarVerlies"
                                    id="startBoekjaarVerlies"
                                    placeholder="dd-mm-jjjj"
                            >
                            </snelstart-ui-date-form-control>
                        </div>

                        <div class="col-auto">
                            <snelstart-ui-date-form-control
                                    [label]="i === 0 ? 'Einde' : ''"
                                    [required]="true"
                                    class="custom-input-150"
                                    formControlName="eindBoekjaarVerlies"
                                    id="eindBoekjaarVerlies"
                                    placeholder="dd-mm-jjjj"
                            >
                            </snelstart-ui-date-form-control>
                        </div>

                        <div class="col-auto">
                            <snelstart-ui-number-form-control
                                    [label]="i === 0 ? 'Te verrekenen verlies' : ''"
                                    [showAllDecimals]="false"
                                    align="right"
                                    class="me-1 custom-input-200"
                                    formControlName="teVerrekenenVerlies"
                                    id="teVerrekenenVerlies"
                                    prefix="€"
                            >
                            </snelstart-ui-number-form-control>
                        </div>

                        <div class="col-auto">
                            <snelstart-ui-number-form-control
                                    [label]="i === 0 ? 'Carry back' : ''"
                                    [showAllDecimals]="false"
                                    align="right"
                                    class="me-1 custom-input-200"
                                    formControlName="teVerrekenenVerliesNaarVorigBoekjaar"
                                    id="teVerrekenenVerliesNaarVorigBoekjaar"
                                    prefix="€"
                            >
                            </snelstart-ui-number-form-control>
                        </div>

                        <div class="col-auto">
                            <snelstart-ui-button
                                    (click)="verwijderRij(i)"
                                    [class]="i === 0 ? 'firstrowbutton' : ''"
                                    icon="trash"
                                    iconType="light"
                                    id="buttonDelete"
                                    size="medium"
                                    type="secondary"
                            >
                            </snelstart-ui-button>
                        </div>
                    </div>
                </div>
            }
        </div>
    </form>

    <snelstart-ui-button
            (click)="addRij()"
            [id]="specificatieVerliezen.length === 0 ? 'cancelA' : 'cancelB'"
            class="snelstart-ui-button pb-3"
            icon="plus"
            type="link"
    >{{ specificatieVerliezen.length === 0 ? 'Vennootschap invullen' : 'Vennootschap toevoegen' }}
    </snelstart-ui-button>
}
